export default {
  id: 'AnnouncementPage',
  code: 'CN',
  text: {
    'Announcement List': '公告列表',
    'Search Announcement': '搜索公告',
    'All': '全部公告',
    'Published': '已发布公告',
    'Draft': '草稿公告',
    'New Announcement': '新建公告',
    'MMM DD, YYYY': 'YYYY年MM月DD日',
    'ddd, MMM DD YYYY': 'YYYY年MM月DD日ddd',
    'Publisher: {name}': '发布者：{name}',
    'Published Time: {time}': '发布时间：{time}',
    'Proceed to delete announcement?': '确认删除公告？',
    'All Teachers and Students': '全体师生',
    'Send To: ': '发送至：',
    'Proceed to publish announcement?': '确认发布公告？',
    'Search by title': '请输入公告标题搜索',
    'Send': '发送',
    'Sent': '已发送',
    'You do not have permission to edit announcement': '您无权修改公告',
    'Sort by': '排序',
    'Creation Time: Newest to Oldest': '按创建时间：由新到旧',
    'Creation Time: Oldest to Newest': '按创建时间：由旧到新',
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Announcement/locale.js